import SimeraDashboard from '../../SimeraDashboard/SimeraDashboard';
import InternalDashboardPages from '../../../constants/InternalDashboardPages';

const SimeraDashboardScreenCandidates = () => {
  return <SimeraDashboard page={InternalDashboardPages.CANDIDATES} />;
};

export default SimeraDashboardScreenCandidates;
